// import type { EventSchema } from 'cpool-events';
import { z } from 'zod';

import { schemaOffersEuropace, schemaOffersEuropaceSync } from './discriminatedUnions';

// export type OffersTableSchema = {
//     createdAt: Date;
//     loanRequestId: string;
//     requestId: string;
// } & {
//     incompletenessMessages: EventSchema<LoanRequest_EuropaceLoanOffersSuccessResponseReceived>['incompletenessMessages'];
//     offers: EventSchema<LoanRequest_EuropaceLoanOffersSuccessResponseReceived>['offers'];
//     source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE;
// };

export const OffersTableDefinitionZod = z.discriminatedUnion('source', [
    schemaOffersEuropace,
    schemaOffersEuropaceSync,
]);

export type OffersTableSchema = z.infer<typeof OffersTableDefinitionZod>;
export type OffersTableSchemaEuropace = z.infer<typeof schemaOffersEuropace>;
export type OffersTableSchemaEuropaceSync = z.infer<typeof schemaOffersEuropaceSync>;
